import Class from './c-widget-tab';
import './c-widget-tab@';

export default Class;